import {
    AlertTypes,
    AuthActions,
    AuthGState,
    Box,
    CssBaseline,
    Footer,
    Logout,
    MainLoader,
    Navbar,
    ThemeProvider,
    apiClient,
    darkTheme,
    getAllOrgsIdsForUserByServiceName,
    setAlert,
    theme,
    useFavoriteTheme,
} from "@leap4/frontend";
import { useEffect, useMemo, useState } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import Routes from "../routing/Routes";
import "./App.css";

import { useQuery } from "react-query";
import { ConnectedProps, connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
    BACKEND_SERVICE_NAME,
    advertiserLoginsUrl,
    logoutUrl,
    meMultiUrl,
    requiredAuthRoles
} from "../../config/generals";
import { queryClient } from "../../index";
import { RootState } from "../../interfaces/root-state.interface";
import { AdvertiserLoginsContext } from "../../store/context/AdvertiserLogins";
import { SelectedALContext } from "../../store/context/SelectedAL";
import { AdvertiserLoginsSelect } from "../common/AdvertiserLoginsSelect/AdvertiserLoginsSelect";
import { IALData } from "../modules/home/home";

const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
    selectedOrganization: state.auth.selectedOrganizationId
});
const mapActions = {
    setAlert
}
const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends PropsFromRedux {
    history: History,
    auth: AuthGState,


}

export const FETCH_ADVERTISER_LOGINS = 'fetch_advertiser_logins';
const App = ({ auth, selectedOrganization }: IProps) => {

    const history = useHistory();
    const [selectedTheme, setSelectedTheme] = useFavoriteTheme()
    const location = useLocation();
    const dispatch = useDispatch();
    const [bIsSidebarOpen, SetSideBarOpenState] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [selectedAL, setSelectedAL] = useState('');

    const
        fetchAdvertiserLogins = async (): Promise<IALData[]> => {
            isLoadingGeneral = true
            const x = ((await apiClient.get(advertiserLoginsUrl)).data)
            isLoadingGeneral = false
            return x
        }
    const {
        data: advertiserLogins,
        isFetching: isFetchingAL,
        isLoading: isLoadingAL,
        isRefetching: isRefetchingAL,
        refetch: refetchAdvertiserLogins,


    } = useQuery([FETCH_ADVERTISER_LOGINS, selectedOrganization], fetchAdvertiserLogins, {
        refetchOnWindowFocus: false,
        onError: (err: Error) => {
            queryClient.setQueryData(FETCH_ADVERTISER_LOGINS, [])
            setAlert({ msg: err.message, type: AlertTypes.FAILURE })
        },
        onSuccess: (advertiserLogins: IALData[]) => {
            const firstAL = advertiserLogins[0]?.aLId;
            setSelectedAL(firstAL)

        },
        cacheTime: 0,
        enabled: Boolean(auth.user),
        retry: 0,
        initialData: null
    })

    useEffect(() => {
        setSelectedAL('')
    }, [selectedOrganization])
    let isLoadingGeneral = isLoadingAL || isFetchingAL;
    const nSidebarWidth = 240;

    const styles = {
        root: {
            display: "flex",
        },
        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            minHeight: { xs: 110, md: 120 },
        },
        content: {
            flexGrow: 1,
            width: "100%",
            margin: "auto",
        },
    };

    const userOrganizations = useMemo(() => {
        if (!auth.user?.organizations) return [];
        return getAllOrgsIdsForUserByServiceName(auth.user, auth.user.organizations as string[], requiredAuthRoles, BACKEND_SERVICE_NAME);
    }, [auth.user?._id, auth.user?.organizations]);

    const handleThemeChange = (checked) => {
        const themeToShow = checked ? theme : darkTheme;
        setSelectedTheme(themeToShow)
    }
    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true)
                await AuthActions.loadUser(dispatch, BACKEND_SERVICE_NAME, meMultiUrl)
            } finally {
                setIsLoading(false)
            }
        }
        )();
    }, []);

    if (isLoading) {
        return <div style={{ margin: "35vh" }}>
            <MainLoader />
        </div>
    }


    return (
        <>
            <ThemeProvider theme={selectedTheme}>
                <Box sx={styles.root}>
                    <CssBaseline />
                    {auth?.user && (
                        <Navbar
                            bIsSidebarOpen={bIsSidebarOpen}
                            handleDrawerClose={() => SetSideBarOpenState(false)}
                            handleDrawerOpen={() => SetSideBarOpenState(true)}
                            auth={{ isAuthenticated: true }}
                            ui={{ nSidebarWidth, nNavbarHeight: 78 }}
                            orgsWithPermssions={userOrganizations}
                            location={location.pathname}
                            links={[]}
                            updateCheckedToFather={(checked) => {
                                handleThemeChange(checked);
                            }}
                            title={"Advertiser Logins"}
                            logoImageUrl={""}
                            logout={{
                                text: "Logout",
                                action: async () => await AuthActions.logout(dispatch, history, logoutUrl),
                                icon: <Logout />,
                            }}
                            mainGridProps={{ justifyContent: "flex-end" }}
                            childrenGridProps={{}}
                        >
                            <AdvertiserLoginsSelect
                                advertiserLogins={advertiserLogins}
                                selectedAL={selectedAL}
                                isLoading={isLoading}
                                setSelectedAL={setSelectedAL}
                                setAlert={setAlert}
                            />
                        </Navbar>
                    )}

                    <Box component="main" sx={styles.content}>
                        <Box sx={styles.toolbar} />
                        <AdvertiserLoginsContext.Provider value={{ advertiserLogins, refetchAdvertiserLogins, isLoadingAL }}>
                            <SelectedALContext.Provider value={{ selectedAL }}>
                                {!isLoadingAL ? (
                                    <Switch>
                                        <Route component={Routes} />
                                    </Switch>
                                ) : (
                                    <Box sx={{ position: 'absolute', top: '35%', left: '35%' }}>
                                        <MainLoader />
                                    </Box>
                                )}
                            </SelectedALContext.Provider>
                        </AdvertiserLoginsContext.Provider>
                    </Box>
                </Box>
                <Footer
                    text={""}
                    logoUrl={""}
                    tagline={""}
                    description={""}
                    hideTags={true}
                    disableCopyrights={true}
                />
            </ThemeProvider>
        </>
    );
};


export default connector(App);
